'use strict';

frontendApp.factory('LoadFileService', ['$resource', '$rootScope', '$q', '$filter', 'ConfigService', 'ResourceWrapperService', function ($resource, $rootScope, $q, $filter, ConfigService, ResourceWrapperService) {

  var _service = {
    loadfiles: []
  };

  var RawLoadFileResource = $resource(ConfigService.getServerBaseUrlForResource() + '/project/:projectId/loadfile/:id',
    {'id': '@id', 'projectId': '@projectId'},
    {'update': {method: 'PUT'}});

  var LoadFile = ResourceWrapperService.WrapActions(RawLoadFileResource);

  _service.create = function (projectId, source) {
    return new LoadFile({
      projectId: projectId,
      source: source
    });
  };

  return _service;

}]);
